import { render } from "./App.vue?vue&type=template&id=5d72429a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5d72429a&lang=css"

import exportComponent from "D:\\CLionProjects\\vue_phone\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__